import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, BarChart3Icon, LayoutGridIcon, CalendarIcon, BookIcon, PrinterIcon, CheckCircleIcon } from 'lucide-react';
export function ValueStackSection() {
  const items = [{
    icon: BookOpenIcon,
    name: 'Manual completo: Mente Clara, Mamá Facturando',
    detail: '43 páginas de método puro'
  }, {
    icon: BarChart3Icon,
    name: 'El Mapa de Energía del Día',
    detail: 'Para saber cuándo usar tu mejor cerebro'
  }, {
    icon: LayoutGridIcon,
    name: 'El Sistema de 3 Bloques',
    detail: 'Para vender sin estar conectada 24/7'
  }, {
    icon: CalendarIcon,
    name: 'Plan de Implementación de 7 Días',
    detail: 'Para que realmente lo apliques'
  }, {
    icon: BookIcon,
    name: 'Glosario Visual',
    detail: 'Todo explicado en lenguaje de mamá, no de médico'
  }, {
    icon: PrinterIcon,
    name: 'Guía Rápida para imprimir',
    detail: 'Los 3 interruptores en una página para tu escritorio'
  }];
  return <section className="w-full bg-[#FFF8F0] px-4 md:px-6 py-6 md:py-24 text-center" data-id="element-369">
      <div className="max-w-4xl mx-auto" data-id="element-370">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-371">
          <p className="text-sm uppercase tracking-[0.2em] text-[#D4A853] font-bold mb-3 md:mb-4" data-id="element-372">
            Todo en un solo PDF
          </p>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2D2D2D] mb-3 md:mb-4" data-id="element-373">
            Todo lo que recibes{' '}
            <span className="text-[#E8734A]" data-id="element-374">hoy mismo:</span>
          </h2>
          <p className="text-base md:text-lg text-[#2D2D2D] opacity-70 mb-5 md:mb-14 max-w-2xl mx-auto font-medium" data-id="element-375">
            Un solo PDF descargable con todo lo que necesitas para transformar
            tu productividad en{' '}
            <span className="text-[#D4A853] font-bold" data-id="element-376">7 días</span>
          </p>

          {/* Items grid */}
          <div className="grid sm:grid-cols-2 gap-2 md:gap-5 max-w-3xl mx-auto mb-5 md:mb-14 text-left" data-id="element-377">
            {items.map((item, index) => {
            const Icon = item.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 15
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.08
            }} className="bg-white rounded-xl md:rounded-2xl p-4 md:p-6 shadow-md border border-[#F5E6DC] flex items-start gap-3 md:gap-4" data-id="element-378">
                  <div className="flex-shrink-0 w-10 md:w-12 h-10 md:h-12 bg-[#E8734A]/10 rounded-lg md:rounded-xl flex items-center justify-center" data-id="element-379">
                    <Icon className="w-5 md:w-6 h-5 md:h-6 text-[#E8734A]" data-id="element-380" />
                  </div>
                  <div data-id="element-381">
                    <p className="font-bold text-[#2D2D2D] mb-1 leading-tight" data-id="element-382">
                      {item.name}
                    </p>
                    <p className="text-sm text-[#2D2D2D] opacity-60" data-id="element-383">
                      {item.detail}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>

          {/* Pricing card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="max-w-xl mx-auto" data-id="element-384">
            <div className="bg-[#2D2D2D] rounded-2xl md:rounded-3xl p-5 md:p-14 shadow-2xl relative overflow-hidden" data-id="element-385">
              {/* Glow effects */}
              <div className="absolute -top-16 -right-16 w-48 h-48 bg-[#E8734A] rounded-full opacity-10 blur-3xl" data-id="element-386" />
              <div className="absolute -bottom-16 -left-16 w-48 h-48 bg-[#D4A853] rounded-full opacity-10 blur-3xl" data-id="element-387" />

              <div className="relative z-10" data-id="element-388">
                <p className="text-sm uppercase tracking-[0.2em] text-white/40 font-bold mb-4 md:mb-6" data-id="element-389">
                  Valor percibido
                </p>

                {/* Struck-through price with red line */}
                <div className="relative inline-block mb-2 md:mb-3" data-id="element-390">
                  <span className="text-4xl md:text-6xl font-black text-white/30" data-id="element-391">
                    $47 USD
                  </span>
                  <div className="absolute top-1/2 -left-2 -right-2 h-1 bg-red-500 -rotate-6 rounded-full" data-id="element-392" />
                </div>

                <div className="w-12 h-0.5 bg-white/20 mx-auto my-3 md:my-6" data-id="element-393" />

                <p className="text-sm uppercase tracking-[0.2em] text-[#D4A853] font-bold mb-3 md:mb-4" data-id="element-394">
                  Precio de lanzamiento
                </p>

                <div className="flex items-baseline justify-center gap-2 mb-3 md:mb-6" data-id="element-395">
                  <span className="text-5xl md:text-8xl font-black text-white" data-id="element-396">
                    $6.36
                  </span>
                  <span className="text-xl text-white/50 font-medium" data-id="element-397">USD</span>
                </div>

                {/* Savings badge */}
                <div className="inline-flex items-center gap-2 bg-[#D4A853] text-white px-5 md:px-6 py-2.5 md:py-3 rounded-full shadow-lg mb-5 md:mb-8" data-id="element-398">
                  <span className="text-xl md:text-2xl font-black" data-id="element-399">86%</span>
                  <span className="text-xs md:text-sm font-bold uppercase tracking-wide" data-id="element-400">
                    de ahorro
                  </span>
                </div>

                {/* What's included reminder */}
                <div className="bg-white/5 rounded-xl md:rounded-2xl p-4 md:p-6 border border-white/10" data-id="element-401">
                  <p className="text-white/60 text-sm font-medium mb-3 md:mb-4" data-id="element-402">
                    Incluye:
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-403">
                    {['Manual completo (43 pág.)', 'Mapa de Energía', 'Sistema de 3 Bloques', 'Plan de 7 Días', 'Glosario Visual', 'Guía Rápida imprimible'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-404">
                        <CheckCircleIcon className="w-4 h-4 text-[#D4A853] flex-shrink-0" data-id="element-405" />
                        <span className="text-white/70 text-xs font-medium" data-id="element-406">
                          {item}
                        </span>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Trust signals */}
          <div className="mt-4 md:mt-8 flex flex-wrap justify-center gap-3 md:gap-6 text-xs md:text-sm text-[#2D2D2D] font-bold opacity-60" data-id="element-407">
            <span className="flex items-center gap-2" data-id="element-408">
              <CheckCircleIcon className="w-4 md:w-5 h-4 md:h-5 text-[#D4A853]" data-id="element-409" />
              Descarga instantánea
            </span>
            <span className="flex items-center gap-2" data-id="element-410">
              <CheckCircleIcon className="w-4 md:w-5 h-4 md:h-5 text-[#D4A853]" data-id="element-411" />
              PDF compatible con todo
            </span>
            <span className="flex items-center gap-2" data-id="element-412">
              <CheckCircleIcon className="w-4 md:w-5 h-4 md:h-5 text-[#D4A853]" data-id="element-413" />
              Garantía de 7 días
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}